import { Injectable } from '@angular/core';
import { ApiService, RepositoryImpl } from '@homeleite/arch';
import { AnimalSummary } from '../animal';
import { AnimalEventEntity } from './animal-events.entity';

@Injectable({ providedIn: 'root' })
export class AnimalEventsApiRepository extends RepositoryImpl<AnimalEventEntity, AnimalEventEntity> {
    constructor(api: ApiService) {
        super(api.root.path('/animalEvents'), AnimalEventEntity, AnimalEventEntity);
    }
}
